import React from 'react'
import VotingDashboard from "./components/Voting"
import FinishedDashboard from './components/Finished/FinishedDashboard'
import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import CurrentDashboard from './components/Current/CurrentDashboard'

export default function SalonDashboard() {
    const { salon } = useSalonManagerContext()

    switch (salon.state.type) {
        case 'current':
            return <CurrentDashboard />
        case 'voting':
            return <VotingDashboard />
        case 'finished':
            return <FinishedDashboard />
        default:
            return null
    }
    
}